import { render, staticRenderFns } from "./kycManage.vue?vue&type=template&id=3e4b40e7&scoped=true"
import script from "./kycManage.vue?vue&type=script&lang=js"
export * from "./kycManage.vue?vue&type=script&lang=js"
import style0 from "./kycManage.vue?vue&type=style&index=0&id=3e4b40e7&prod&scoped=true&lang=css"
import style1 from "./kycManage.vue?vue&type=style&index=1&id=3e4b40e7&prod&lang=css"
import style2 from "./kycManage.vue?vue&type=style&index=2&id=3e4b40e7&prod&lang=css"
import style3 from "./kycManage.vue?vue&type=style&index=3&id=3e4b40e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b40e7",
  null
  
)

export default component.exports